<template>
  <el-dialog
    v-if="visible"
    show-close
    :visible.sync="visible"
    width="800px"
    :title="title"
    :close-on-click-modal="false"
    :before-close="() => close()"
    destroy-on-close
    append-to-body
    v-el-dialog-drag
  >
    <div>
      <el-checkbox-group v-model="qualityIssues" placement="column">
        <div v-for="(t, key) in issuesList" :key="key" class="mb-4">
          <div
            style="color: #101010; height: 20px;font-size: 18px;"
            class="mb-3"
          >
            {{ t.qualityIssuesGroup }}
          </div>
          <div>
            <el-checkbox
              v-for="option in t.items"
              :key="option.qualityIssuesTitle"
              :label="option.qualityIssuesTitle"
            >
              {{ option.qualityIssuesTitle }}
            </el-checkbox>
          </div>
        </div>
      </el-checkbox-group>
    </div>

    <span slot="footer">
      <el-button size="small" @click="close()">
        {{ $l('INDEX.btn_cancel') || '取消' }}
      </el-button>
      <el-button type="primary" size="small" @click="confirm()">
        {{ $l('INDEX.btn_confirm') || '确认' }}
      </el-button>
    </span>
  </el-dialog>
</template>
<script>
import lodash from 'lodash'
export default {
  components: {},
  props: {
    visible: { type: Boolean, default: false },
    title: { type: String, default: '' },
    type: { type: String, default: 'radio' },
    height: { type: Number, default: 360 },
    orderCode: { type: String, default: '' },
    size: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      issuesList: [],
      qualityIssues: [],
    }
  },
  async mounted() {
    await this.getData()
  },

  methods: {
    async getData() {
      await this.$api
        .mrpQualityIssuesListApi({})
        .then((res) => {
          this.issuesList = lodash.mapValues(
            lodash.groupBy(res.body.data, 'qualityIssuesGroup'),
            (items) => {
              const { qualityIssuesGroup } = items[0]
              return { qualityIssuesGroup, items }
            }
          )
        })
        .catch(() => {})
    },
    confirm() {
      const qualityIssuesTitle = lodash.join(this.qualityIssues, '、')
      if (!qualityIssuesTitle) {
        this.$message.warning('请选择问题')
        return
      }
      // notPassQty: 1,
      this.$emit('confirm', qualityIssuesTitle)
    },
    close() {
      this.$emit('update:visible', false)
      this.$emit('close')
    },
  },
}
</script>
